<template>
  <LayoutContainer
    :props="props"
    :class="{
      'kaer-row1by1-wrap': props.numPerRow === '1',
      'kaer-row1by2-wrap': props.numPerRow === '2',
      'kaer-row1by3-wrap': props.numPerRow === '3',
      'kaer-row1byn-wrap': props.numPerRow === '9999',
    }"
  >
    <h3 class="title" v-if="props.title || props.linkUrl" ref="doctorList">
      <span v-if="props.title">{{ props.title }}</span>
      <button class="btn" v-if="props.linkUrl" @click="jumpMore">更多医生</button>
    </h3>
    <div class="row" v-for="n in rowNum" :key="n">
      <div
        class="doctor-card-small"
        :class="[!doctor && 'hidden', isInKaer && !(doctor || {}).name && 'error-box']"
        v-for="(doctor, index) in list.slice((n - 1) * props.numPerRow, n * props.numPerRow)"
        :key="(doctor || {}).doctorId || index"
        @click="jump(doctor)"
      >
        <template v-if="doctor">
          <div
            class="avatar"
            :style="{
              backgroundImage: `url(${
                doctor.avatar || 'http://static.91jkys.com/upload/202107/12/1acf0f5141fc4d5993d6b953ec190da0.png'
              })`,
            }"
          ></div>
          <div class="depart" v-if="props.numPerRow !== '1'">
            <div class="font10 center">{{ doctor.department }}</div>
          </div>
          <div class="name">
            <span class="d-name"> {{ doctor.name }}</span>
            <span class="job-title">{{ doctor.jobTitle }}</span>
          </div>
          <div class="hospital font10">
            <span v-if="props.numPerRow === '1'" style="margin-right: 8px">{{ doctor.department }}</span
            >{{ doctor.hospital }}
          </div>
          <div class="specialties" v-if="props.numPerRow < 3">
            {{ doctor.specialties ? '擅长：' + doctor.specialties : `擅长：${doctor.department}疾病的诊断和治疗` }}
          </div>
          <template v-if="doctor.customPrice">
            <div class="free-text">
              ¥{{ doctor.customPrice }}
            </div>
          </template>
          <template v-else>
            <template v-if="props.numPerRow > 2">
              <div
                class="money font10"
                v-if="!doctor.isInquiryed"
                :class="[!(doctor.price && doctor.isFree) && 'hidden']"
              >
                ¥{{ doctor.price }}
              </div>
              <div class="visited" v-else>问诊过</div>
            </template>

            <div class="free-text">
              {{ doctor.isFree ? '限时免费' : `¥${doctor.price || 0}` }}

              <template v-if="props.numPerRow <= 2">
                <span
                  class="money font10"
                  v-if="!doctor.isInquiryed"
                  :class="[!(doctor.price && doctor.isFree) && 'hidden']"
                  >¥{{ doctor.price }}</span
                >
                <span class="visited" v-else>问诊过</span>
              </template>
            </div>
          </template>

          <button class="zy-btn" v-if="props.numPerRow === '1' && props.btnText"> {{ props.btnText }}</button>

          <!-- kaer 输入id查询不到提醒 -->
          <div class="error-msg" v-if="isInKaer && !(doctor || {}).name">
            id: <span style="color: blue">{{ (doctor || {}).queryId }}</span
            >不存在，请检查
          </div>
        </template>
      </div>
    </div>
  </LayoutContainer>
</template>

<script>
import LayoutContainer from '@/components/layout-container';
import { fetchPostApiSearchYizhenPageDoctors, fetchConsultStatus } from '@/api';
import { trackIds, staticUrl } from '@/config';

import { getUrlParam } from '@/utils/utils';
import { uploadData } from '@/utils/uploadData';

export default {
  components: { LayoutContainer },
  props: {
    componentId: String,
    props: {
      type: Object,
      default() {
        return {};
      },
    },
    clickDoctorCode: String,
  },
  data() {
    return {
      list: [],
      areaName: '',
    };
  },

  watch: {
    list: {
      handler(val) {
        if (this.props.numPerRow !== '9999' && this.props.numPerRow !== '1') {
          const result = val.length % this.props.numPerRow;
          if (result) {
            this.list.length = this.list.length + (this.props.numPerRow - result);
          }
        }
      },
      immediate: true,
    },
    'props.ids': {
      handler() {
        this.fetchData();
      },
      immediate: true,
    },
  },
  computed: {
    rowNum() {
      return Math.ceil(this.list.length / this.props.numPerRow);
    },
    isInKaer() {
      return top.location.href.indexOf('/web/kaer-admin') > -1;
    },
  },

  methods: {
    async jump(doctor) {
      const { doctorId: id, customUrl } = doctor;
      // 接收 doctor-tabs 组件的埋点、或原组件定义的埋点
      this.uploadData(this.clickDoctorCode || trackIds.event[this.props.numPerRow], 'event', {
        doctorId: id,
        kaerComponentId: this.componentId,
      });
      setTimeout(async () => {
        if (customUrl) {
          this.adapt.open(customUrl);
        } else {
          if (this.props.jumpDoctorDetail === '1') {
            this.adapt.goDoctorDetailPage(id);
          } else {
            const url = await this.getJumpUrl(id);
            this.adapt.open(url);
          }
        }
      }, 200);
    },
    async getJumpUrl(id) {
      let url = `${staticUrl}f2e/patient-clinic/#/clinic-payment/${id}`;

      if (this.env.inAPP) {
        const { doctorInfo } = await fetchConsultStatus({
          doctorId: id,
          areaName: this.areaName,
          channel: getUrlParam('channel'),
        });
        url = `native://page-consultation-pay:{"strPrescriptionOffer":{"doctorInfo":${JSON.stringify(doctorInfo)}}}`;
      }
      return url;
    },
    jumpMore() {
      this.props.linkUrl && this.adapt.open(this.props.linkUrl);
    },
    async fetchData() {
      const ids = this.props.ids;
      if (ids.length <= 0) {
        return;
      }
      const doctorIds = ids.map((item) => item.itemCode);
      const doctorIdsMap = ids.reduce((pre, item) => {
        pre[item.itemCode] = item;
        return pre;
      }, {})

      const res = await fetchPostApiSearchYizhenPageDoctors({
        doctorIds,
        departmentLevel: this.props.departmentLevel * 1,
      });
      this.areaName = res.areaName;

      uploadData(
        trackIds.view[this.props.numPerRow],
        'event',
        { kaerComponentId: this.componentId },
        this.$refs.doctorList
      );

      if (this.isInKaer) {
        this.list = doctorIds.map((id) => {
          const existDoctor = res.list.find((listObj) => listObj.doctorId == id);
          if (existDoctor) {
            return { queryId: id, ...existDoctor };
          }
          return { queryId: id };
        });
      } else {
        this.list = res.list.map((item) => {
          const prop = doctorIdsMap[item.doctorId];
          return {
            ...item,
            customPrice: prop.customPrice,
            customUrl: prop.customUrl
          }
        });
        console.log(this.list);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.my-font-size(@fs: 10px ) {
  font-size: @fs;
}

* {
  box-sizing: border-box;
}

button {
  background: unset;
}
.hidden {
  visibility: hidden;
}

h3.title {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
  margin: 12px 0 8px;
  .btn {
    width: 72px;
    height: 24px;
    border-radius: 12px;
    border: 0.5px solid #d9d9d9;
    font-size: 12px;
    line-height: 24px;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 2;
    float: right;
  }
}

.row {
  display: flex;
  white-space: nowrap;
  width: 100%;
  overflow: auto;
}

.kaer-row1by1-wrap {
  .row:not(:first-of-type) {
    margin-top: 8px;
  }
  .doctor-card-small {
    width: 100%;
    border: 0;
    .depart,
    .hospital,
    .specialties,
    .money,
    .zy-btn {
      .my-font-size(12px);
    }
    .name {
      .my-font-size(16px);
      font-weight: 500;
    }
    .job-title {
      margin-left: 6px;
      font-weight: 500;
    }
    .job-title,
    .visited,
    .free-text {
      .my-font-size(14px);
    }
  }
  .doctor-card-small {
    position: relative;
    padding: 16px 12px;
    > * {
      padding-left: 60px;
    }
    * {
      text-align: left !important;
      width: 100%;
    }

    .avatar {
      padding-left: 0px;
      position: absolute;
      top: 16px;
      left: 12px;
      width: 48px;
      height: 48px;
      align-self: flex-start;
      flex: 1;
      background-size: cover;
    }
    .specialties {
      margin: 12px 0 16px;
    }
    .free-text {
      margin-bottom: 7px;
    }

    .zy-btn {
      position: absolute;
      right: 12px;
      bottom: 16px;
      padding-left: 0;
      width: 72px;
      height: 28px;
      border-radius: 14px;
      border: 0.5px solid #1e8dff;
      color: #1e8dff;
      line-height: 28px;
      text-align: center !important;
      background-color: unset;
    }
  }
}

.kaer-row1by2-wrap {
  .row:not(:first-of-type) {
    margin-top: 8px;
  }
  .doctor-card-small {
    width: 50%;
    &:not(:nth-child(2n)) {
      margin-right: 8px;
    }
    .avatar {
      width: 56px;
      padding-top: 56px;
    }
    .depart,
    .specialties,
    .hospital,
    .money {
      .my-font-size(12px);
    }
    .name,
    .visited,
    .free-text {
      .my-font-size(14px);
    }
    .name {
      font-weight: 500;
      margin-top: 8px;
      display: inline-flex;
      justify-content: center;
    }

    .d-name {
      box-sizing: content-box;
      display: inline-block;
      width: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: none;
      flex-grow: 1;
      text-align: right;
      margin-right: 3px;
    }

    .job-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      flex-grow: 1;
    }

    .free-text {
      margin-top: 16px;
    }
    .depart {
      width: 103px;
    }
  }
}

.kaer-row1by3-wrap {
  .row:not(:first-of-type) {
    margin-top: 8px;
  }
  .doctor-card-small {
    width: 33.33%;

    &:not(:nth-child(3n)) {
      margin-right: 6px;
    }
  }
}

.kaer-row1byn-wrap {
  background: #fff;
  border-radius: 8px;
  padding: 0;

  h3 {
    padding: 0 12px;
  }
  .row {
    width: unset;
    overflow: auto;
    padding-bottom: 16px;
  }
  .doctor-card-small {
    width: 122px;
    flex: none;
    border: 1px solid #eeeeee;
    margin-right: 6px;
    &:first-of-type {
      margin-left: 12px;
    }

    &:last-of-type {
      margin-right: 12px;
    }
  }
}

.kaer-row1by3-wrap,
.kaer-row1byn-wrap {
  .doctor-card-small {
    padding: 16px 6px;

    .depart {
      margin-top: 6px;
    }
    .hospital {
      margin-top: 6px;
    }
    .free-text {
      margin-top: 4px;
    }
    .name {
      margin-top: 8px;
      font-weight: 400;
      display: inline-flex;
      justify-content: center;
    }

    .d-name {
      box-sizing: content-box;
      display: inline-block;
      width: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: none;
      flex-grow: 1;
      text-align: right;
      margin-right: 3px;
    }

    .job-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      flex-grow: 1;
    }

    .money {
      margin-top: 12px;
    }

    .avatar {
      width: 48px;
      padding-top: 48px;
    }

    .depart,
    .hospital,
    .money {
      .my-font-size(10px);
    }
    .name,
    .specialties,
    .visited,
    .free-text {
      .my-font-size(12px);
    }
  }
}

.doctor-card-small {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fcfeff;
  border-radius: 6px;
  background: #ffffff;
  font-size: 0;
  overflow: hidden;
  border-radius: 6px;
  border: 0;
  padding: 16px 12px;

  &.hidden {
    visibility: hidden;
  }

  .avatar {
    border-radius: 50%;
    background-color: #eee;
    background-size: cover;
  }

  .depart {
    margin-top: 12px;
    width: 76px;
    height: 16px;
    // font-size: 10px;
    line-height: 16px;
    background: #ebf8ff;
    border-radius: 2px;
    font-weight: 400;
    color: #1e8dff;
    padding: 0 3px;

    .font10 {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }

  .name {
    width: 100%;
    margin-top: 6px;
    // font-size: 12px;
    font-weight: 500;
    color: #262626;
    // line-height: 12px;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .hospital {
    width: 100%;
    line-height: 14px;
    margin-top: 8px;
    font-weight: 400;
    color: #262626;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    // font-size: 10px;
  }

  .specialties {
    height: 36px;

    font-weight: 400;
    color: #262626;
    line-height: 21px;
    margin-top: 12px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 100%;
    white-space: normal;

    color: #8c8c8c;

    // font-size: 12px;
    line-height: 18px;
  }

  .money {
    // font-size: 10px;
    margin-top: 16px;
    color: #bfbfbf;
    text-decoration: line-through;
    font-weight: 400;
  }

  .visited {
    margin-top: 8px;
    // font-size: 12px;
    font-weight: 400;
    color: #8c8c8c;
    background: #f1f1f1;
    border-radius: 2px;
    padding: 1px 3px;
  }

  .free-text {
    margin-top: 6px;
    height: 12px;
    // font-size: 12px;
    font-weight: 500;
    color: #ff4e47;
    line-height: 12px;
  }
}
.center {
  text-align: center;
}

.error-box {
  border: 3px solid red;
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: #fff;
  background: rgba(10 10 10 / 44%);
  text-align: center;
  .error-msg {
    display: block;
    position: absolute;
    top: 10%;
    background: red;
    white-space: normal;
    padding: 3px 10px;
  }
}
</style>
